<script setup lang="ts">
import { mapSize, mapWeight } from '~/components/UI/DesignSystem/utils'

const props = defineProps<{
  size?: string
  weight?: string
  muted?: boolean
  mutedDark?: boolean
  whiteText?: boolean
}>()
const size = mapSize(props.size)
const weight = mapWeight(props.weight)

const classes = computed(() => {
  return {
    [`text-${size}`]: true,
    [`font-${weight.toString()}`]: true,
    'text-white': props.whiteText,
    ['text-gray-500']: props.muted,
    ['text-gray-600']: props.mutedDark,
    ['text-gray-900']: !props.muted && !props.whiteText,
  }
})
</script>

<template>
  <p :class="classes">
    <slot></slot>
  </p>
</template>
